module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot2-f2f950d0e6261ee41bb02910305d47f2.png";